export default {
  SET_MONEY_REPORT(state, data) {
    state.moneyReport = data
  },
}
